import { render, staticRenderFns } from "./ProjectDropdown.vue?vue&type=template&id=41c2f882&"
import script from "./ProjectDropdown.vue?vue&type=script&lang=ts&"
export * from "./ProjectDropdown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports